// Do not show YouTube fallback thumbnail
// https://github.com/latitudelabs/Lumiere/issues/796
const isUglyYouTubeThumbnail = img => {
    return (
        /ytimg/.test(img.src) &&
        img.naturalWidth === 120 &&
        img.naturalHeight === 90
    )
}

export default isUglyYouTubeThumbnail
